import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import MenuEditorSidepanel from 'modules/menu/components/MenuEditorSidepanel';
import { useAllOfferImages } from 'modules/shared-menu/hooks/useAllOfferImages';
import { useListingManagerImageGallery } from 'modules/shared-menu/hooks/useListingManagerImageGallery';

import { ImageCard } from './ImageCard';
import { Pagination } from './Pagination';

const PAGE_SIZE = 12;
const IMAGE_BASE_URL = process.env.IMAGE_RESIZER_PROXY_URI + '/assets/';

type Props = {
  onClose: () => void;
};

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: 240px 240px;
  grid-auto-rows: 168px;
  gap: 16px;
  padding: 24px;
`;

export const ImageGallerySidePanel = ({ onClose }: Props) => {
  const intl = useIntl();
  const { imageAssets, fetchNextPage, hasNextPage, isFetchingNextPage } = useListingManagerImageGallery({
    size: PAGE_SIZE,
  });

  const { allOfferImagesSet } = useAllOfferImages();

  return (
    <MenuEditorSidepanel
      id="images"
      title={intl.formatMessage({ id: 'shared-menu.editor.image-gallery.title' })}
      onClose={onClose}
    >
      <ImageGrid>
        {imageAssets.map(({ name, id, blurhash }) => (
          <ImageCard
            key={id}
            attachedToOffer={allOfferImagesSet.has(IMAGE_BASE_URL + id)}
            blurhash={blurhash}
            name={name}
            src={IMAGE_BASE_URL + id}
          />
        ))}
        {hasNextPage && (
          <Pagination
            fetchNextPage={fetchNextPage}
            skeletonCount={PAGE_SIZE / 2}
            isFetchingNextPage={isFetchingNextPage}
          />
        )}
      </ImageGrid>
    </MenuEditorSidepanel>
  );
};
